'use client'

import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { THEME_COLORS } from '../../theme/colors'

export default function NoResultsOverlay({ noResultsText }: { noResultsText?: string }) {
  const [isDark, setIsDark] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return
    const mql = window.matchMedia('(prefers-color-scheme: dark)')
    setIsDark(mql.matches)
    const handler = () => setIsDark(mql.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [])

  return (
    <Box sx={{
      textAlign: 'center',
      p: 4,
      color: isDark ? THEME_COLORS.dark.text : THEME_COLORS.light.text,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'absolute',
      inset: 0,
      backgroundColor: isDark ? THEME_COLORS.dark.bg : THEME_COLORS.light.bg,
      zIndex: 9999,
    }}>
      <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem' }}>
        {noResultsText}
      </Typography>
      <Typography variant="body2" sx={{ mt: 1, opacity: 0.85 }}>
        Try adjusting filters or search to see more results.
      </Typography>
      <div style={{
        marginTop: 16,
        width: 36,
        height: 3,
        borderRadius: 2,
        background: THEME_COLORS.primary,
        opacity: 0.5,
      }} />
    </Box>
  )
}
